import React, { useState } from 'react';
import LazyLoad from 'react-lazyload';
import { motion } from 'framer-motion';
import {
  OuterSection,
  InnerSection,
  Title,
  TitleSpecialText,
  ToggleTrack,
  ToggleThumb,
  TabsContainer,
  InterviewLabel,
  ContentContainer,
  ContentTextContainer,
  ContentSpecialText,
  ContentParaText,
  ContentSecondaryText,
  ContentVideoContainer,
  ContentVideo,
} from './styles';

export default function InterviewProblems({ cloudFront, variant }) {
  const [activeTab, setActiveTab] = useState('problem');
  const handleToggle = (position) => setActiveTab(position);
  return (
    <OuterSection>
      <InnerSection>
        <Title>
          Crack interview problems with a{' '}
          <TitleSpecialText variant={variant}>
            hint <span className="weight-500">&#10132;</span> solution
          </TitleSpecialText>{' '}
          approach
        </Title>
        <TabsContainer>
          <InterviewLabel variant={variant} onClick={() => handleToggle('problem')}>
            Problem <span className="showOnLargeMobile">Statement</span>
          </InterviewLabel>
          <InterviewLabel variant={variant} onClick={() => handleToggle('hint')}>
            Hint
          </InterviewLabel>
          <InterviewLabel variant={variant} onClick={() => handleToggle('solution')}>
            Solution
          </InterviewLabel>
        </TabsContainer>
        <ToggleTrack variant={variant}>
          <ToggleThumb variant={variant} activeTab={activeTab} />
        </ToggleTrack>
        <ContentContainer>
          <ContentTextContainer>
            {activeTab === 'problem' && (
              <motion.div animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ duration: 0.5 }}>
                <ContentSpecialText variant={variant}>Problem Statement</ContentSpecialText>
                <ContentParaText>
                  Understand the problem statement in video format with sample input and output. If you know how to solve it, try solving the problem without watching the hint and
                  solution video.
                </ContentParaText>
                <ContentSecondaryText>Got stuck &#10132; Go to Hint</ContentSecondaryText>
              </motion.div>
            )}
            {activeTab === 'hint' && (
              <motion.div animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ duration: 0.5 }}>
                <ContentSpecialText variant={variant}>Hint</ContentSpecialText>
                <ContentParaText>
                  Watch our thought-provoking hint video to approach the problem. In the hint video, we only provide the problem-solving approach with a sample test case. We won't
                  give the solution code.
                </ContentParaText>
                <ContentSecondaryText>Still stuck &#10132; Go to Solution</ContentSecondaryText>
              </motion.div>
            )}
            {activeTab === 'solution' && (
              <motion.div animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ duration: 0.5 }}>
                <ContentSpecialText variant={variant}>Solution</ContentSpecialText>
                <ContentParaText>
                  Got stuck even after watching the hint video? Don't worry. You can go ahead and implement the solution by watching our step-by-step code walkthrough video.
                </ContentParaText>
                <ContentSecondaryText>Relax. It's that simple! </ContentSecondaryText>
              </motion.div>
            )}
          </ContentTextContainer>
          <ContentVideoContainer>
            {activeTab === 'problem' && (
              <LazyLoad offset={0} height={250}>
                <motion.div animate={{ scale: 1, opacity: 1 }} initial={{ scale: 0.95, opacity: 0.5 }} transition={{ duration: 0.5 }}>
                  <ContentVideo data={cloudFront + '/Assets/homePage/InterviewProblemsStatementNew.svg'}>Problem Statement Preview</ContentVideo>
                </motion.div>
              </LazyLoad>
            )}
            {activeTab === 'hint' && (
              <LazyLoad offset={0} height={250}>
                <motion.div animate={{ scale: 1, opacity: 1 }} initial={{ scale: 0.95, opacity: 0.5 }} transition={{ duration: 0.5 }}>
                  <ContentVideo data={cloudFront + '/Assets/homePage/InterviewProblemsHintNew.svg'}>Hint Preview</ContentVideo>
                </motion.div>
              </LazyLoad>
            )}
            {activeTab === 'solution' && (
              <LazyLoad offset={0} height={250}>
                <motion.div animate={{ scale: 1, opacity: 1 }} initial={{ scale: 0.95, opacity: 0.5 }} transition={{ duration: 0.5 }}>
                  <ContentVideo data={cloudFront + '/Assets/homePage/InterviewProblemsSolutionNew.svg'}>Solution Preview</ContentVideo>
                </motion.div>
              </LazyLoad>
            )}
          </ContentVideoContainer>
        </ContentContainer>
      </InnerSection>
    </OuterSection>
  );
}
